module.exports = __webpack_public_path__ + "img/btn_top.1f4a8b38.png";